exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-6a2155f6!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/user/ConfigUser.vue
// module id = 595
// module chunks = 2